enum NonAttendeeApplicationStatus {
  BULK_TICKET_APPLICATION_APPROVAL_PENDING = "BULK_TICKET_APPLICATION_APPROVAL_PENDING",
  BULK_TICKET_APPLICATION_PAYMENT_PENDING = "BULK_TICKET_APPLICATION_PAYMENT_PENDING",
  ORG_ADMIN_APPLICATION_APPROVAL_PENDING = "ORG_ADMIN_APPLICATION_APPROVAL_PENDING",
  VENDOR_APPLICATION_APPROVAL_PENDING = "VENDOR_APPLICATION_APPROVAL_PENDING",
  NON_ATTENDEE_APPLICATION_APPROVAL_PENDING = "NON_ATTENDEE_APPLICATION_APPROVAL_PENDING",
  APPLICATION_REJECTED = "APPLICATION_REJECTED",
  COMPLETED = "COMPLETED",
  BULK_TICKET_PAYMENT_RECEIPT_PENDING = "BULK_TICKET_PAYMENT_RECEIPT_PENDING"
}

export default NonAttendeeApplicationStatus;
